import {FC} from "react";
import {INewsListProps} from "../../types";
import {Button, Dropdown, Empty, Pagination, Skeleton} from "antd";
import type {MenuProps} from "antd";
import "./style.less"
import dayjs from "dayjs";
import {Link} from "react-router-dom";
import {useAuth} from "../../../../context/authContext";
import {NewsItem} from "../../../../types/news";
import {getImageLink} from "../../../../helpers/mainHelpers";
import * as BUCKETS from "../../../../enums/buckets"
import {CalendarOutlined, DeleteOutlined, EditOutlined, MoreOutlined, RightOutlined} from "@ant-design/icons";

const NewsList: FC<INewsListProps> = ({
  newsList,
  confirmDeleteNews,
  editButtonHandler,
  pageSize,
  totalCount,
  onPageChange,
  currentPage,
  isLoading
}) => {
  const {canManageContent} = useAuth()

  const isNew = (createdAt?: string) => Boolean(createdAt && dayjs(createdAt).isAfter(dayjs().subtract(1, "day")))

  const getAdminMenu = (item: NewsItem): MenuProps["items"] => [
    {
      key: "edit",
      icon: <EditOutlined/>,
      label: "Редагувати",
      onClick: () => editButtonHandler(item),
    },
    {
      key: "delete",
      danger: true,
      icon: <DeleteOutlined/>,
      label: "Видалити",
      onClick: () => confirmDeleteNews(item.$id || ""),
    },
  ]

  if (isLoading && newsList.length === 0) {
    return <div className="news-feed news-feed--loading" aria-label="Завантаження новин">
      {[0, 1, 2].map((item) => <div className="news-card-skeleton" key={item}>
        <Skeleton.Image active/>
        <Skeleton active paragraph={{rows: 2}} title={{width: "75%"}}/>
      </div>)}
    </div>
  }

  if (!isLoading && newsList.length === 0) {
    return <div className="news-feed__empty"><Empty description="Новин за вашим запитом не знайдено"/></div>
  }

  return <section className="news-feed" aria-label="Список новин">
    <div className="news-feed__grid">
      {newsList.map((item, index) => {
        const imageUrl = getImageLink({imageId: item.mainImage, bucketId: BUCKETS.MAIN})
        const date = item.created || item.$createdAt

        return <article className={`news-card ${index === 0 ? "news-card--featured" : ""}`} key={item.$id}>
          <Link className="news-card__link" to={`/news/${item.$id}`} aria-label={`Відкрити новину: ${item.title}`}>
            <div className="news-card__media">
              {item.mainImage
                ? <img className="news-card__image" src={imageUrl} alt="" loading={index === 0 ? "eager" : "lazy"}/>
                : <div className="news-card__placeholder" aria-hidden="true">БЦРЛ</div>}
              {isNew(item.$createdAt) && <span className="news-card__badge">Нове</span>}
            </div>
            <div className="news-card__content">
              {date && <time className="news-card__date" dateTime={date}>
                <CalendarOutlined/> {dayjs(date).format("D MMMM YYYY")}
              </time>}
              <h2 className="news-card__title">{item.title}</h2>
              <span className="news-card__more">Читати далі <RightOutlined/></span>
            </div>
          </Link>

          {canManageContent && <Dropdown menu={{items: getAdminMenu(item)}} trigger={["click"]}>
            <Button
              className="news-card__admin"
              type="text"
              shape="circle"
              icon={<MoreOutlined/>}
              aria-label="Керування новиною"
            />
          </Dropdown>}
        </article>
      })}
    </div>

    {totalCount > pageSize && <Pagination
      className="news-feed__pagination"
      current={currentPage}
      total={totalCount}
      pageSize={pageSize}
      showSizeChanger={false}
      onChange={onPageChange}
    />}
  </section>
}

export default NewsList
